import { Genre } from "@server/entities";

import { useStickyStaleSWR } from "../helpers";

export const getGenres = (query: string) =>
  useStickyStaleSWR<Genre[]>(`/genre`, { query });
